import { render } from "./SummaryPrice.vue?vue&type=template&id=5e32a0a0"
import script from "./SummaryPrice.vue?vue&type=script&lang=js"
export * from "./SummaryPrice.vue?vue&type=script&lang=js"

import "./SummaryPrice.vue?vue&type=style&index=0&id=5e32a0a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__